module.exports = require("live/components/extensions/ui/stats");